module.exports = __webpack_public_path__ + "static/media/mapi32_icon_attach.332dd364.ico";